import { InjectionToken } from "@angular/core";
import { IAppConfig } from "../config/app-config";

export const APP_CONFIG = new InjectionToken<IAppConfig>("app-config");
